<div class="d-flex flex-row align-items-center">
  <div class="demographic-source-platform {{selectPlatform}}-icon"></div>
  <ng-select #ngSelect class="form-control demographic-source-select custom-select" required
             [ngClass]="{'has-selected': isSelectedItem() === true}"
             [name]="name"
             [items]="dataSources"
             [disabled]="disabled"
             [multiple]="multiple"
             [closeOnSelect]="!multiple"
             [placeholder]="'channel_specific.placeholder' | translate"
             bindValue="id"
             bindLabel="name"
             [searchable]="false"
             [(ngModel)]="model"
             actionByLevels="Advanced Demographics"
             [actionData]="mpEventData"
             (open)="onOpenDopdown($event)"
             (close)="onBlur($event)"
             (change)="onSelectDemographicSource($event)">
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="d-flex flex-row dm-source-selection-container">
        <div class="source-platform-image {{item.platformName}}-icon">
        </div>
        <div class="source-name-wrapper">
          {{item.name}}
        </div>
      </div>
    </ng-template>
  </ng-select>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic-source-selection/demographic-source-selection.component.html